var _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmentdrilldown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bar-chart 1",
    clipPath: "url(#clip0_206_4220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_4220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath5078"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5076",
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_4220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5080",
    d: "M23.6484 23.2222H0.351562V21.707H23.6484V23.2222Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5084",
    d: "M4.42402 19.2656V21.7068H1.39355V15.3618H4.42402V20.625",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g5086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5088",
    d: "M10.4846 15.5864V21.7068H7.4541V9.20627H10.4846V16.9458",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_206_4220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath5096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5094",
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_206_4220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5100",
    d: "M19.5762 11.3775V21.7068H22.6066V6.83857H19.5762V12.7368",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path5102",
    d: "M16.5461 12.5208H13.5156V21.707H16.5461V12.5208Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g5104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5106",
    d: "M13.701 7.24829L10.2988 5.38735",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g5108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5110",
    d: "M19.9865 3.32901L16.1357 6.9389",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g5112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5114",
    d: "M7.90637 5.74031L3.97168 9.73688",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g5116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5126",
    d: "M4.42402 10.8162C4.42402 11.6531 3.7456 12.3315 2.90879 12.3315C2.07193 12.3315 1.39355 11.6531 1.39355 10.8162C1.39355 9.97939 2.07193 9.30101 2.90879 9.30101C3.7456 9.30101 4.42402 9.97939 4.42402 10.8162Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5130",
    d: "M10.4846 4.66055C10.4846 5.49741 9.80615 6.17578 8.96934 6.17578C8.13248 6.17578 7.4541 5.49741 7.4541 4.66055C7.4541 3.82369 8.13248 3.14531 8.96934 3.14531C9.80615 3.14531 10.4846 3.82369 10.4846 4.66055Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5134",
    d: "M16.5461 7.97512C16.5461 8.81203 15.8677 9.49036 15.0309 9.49036C14.194 9.49036 13.5156 8.81203 13.5156 7.97512C13.5156 7.13826 14.194 6.45989 15.0309 6.45989C15.8677 6.45989 16.5461 7.13826 16.5461 7.97512Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5138",
    d: "M22.6066 2.29299C22.6066 3.12985 21.9282 3.80823 21.0914 3.80823C20.2545 3.80823 19.5762 3.12985 19.5762 2.29299C19.5762 1.45609 20.2545 0.777759 21.0914 0.777759C21.9282 0.777759 22.6066 1.45609 22.6066 2.29299Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_4220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentdrilldown);
export default __webpack_public_path__ + "static/media/segmentdrilldown.cd10d8a38d3e6627923f120bfc25e02b.svg";
export { ForwardRef as ReactComponent };